module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxNzgnIGhlaWdodD0nMjY3Jz48cmVjdCB4PScwJyB5PScwJyB3aWR0aD0nMTc4JyBoZWlnaHQ9JzI2NycgZmlsbD0nI0NDQycvPjx0ZXh0IHg9JzUwJScgeT0nNTAlJyBzdHlsZT0nZG9taW5hbnQtYmFzZWxpbmU6bWlkZGxlO3RleHQtYW5jaG9yOm1pZGRsZTtmb250LXNpemU6MjVweCcgZmlsbD0nI0ZGRic+bG9hZGluZzwvdGV4dD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/loading.svg
// module id = 2CaC
// module chunks = 9